import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppTableComponent, Auth, Form, MessagesComponent, OpnTeamMemberModel, OpnTeamMemberSaveModel, OpnTeamMembersService, RequestsService, RequestStatusUniqueIdentifier, TranslationManager, ViewState } from 'src/common';
import { ActivatedRoute } from '@angular/router';
import { OpnTeamMemberComponent } from 'src/views';

@Component({
  selector: 'opn-team-members',
  templateUrl: 'opn-team-members.component.html'
})

export class OpnTeamMembersComponent implements OnInit {
  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @ViewChild("opnTeamMemberComponent") opnTeamMemberComponent: OpnTeamMemberComponent;
  @Input() requestId: number;
  @Input() state: ViewState;
  viewState = ViewState;

  constructor(private requestService: RequestsService,
    private opnTeamMembersService: OpnTeamMembersService,
    private router: Router,
    private route: ActivatedRoute) { }

  auth = Auth;
  translationManager = TranslationManager;
  requestStatusUniqueIdentifier = RequestStatusUniqueIdentifier;
  form: Form = new Form();

  items: OpnTeamMemberModel[];
  idForDelete: number;
  showDeleteModal: boolean = false;
  requestStatus: string;
  deadlineForCompletion: Date;

  ngOnInit(): void {
    this.getAllInitial();

    this.requestService.getRequestStatusUnique(this.requestId).then(result => {
      this.requestStatus = result.requestStatus;
    });

    this.requestService.deadlineForCompletion(this.requestId).then(result => {
      this.deadlineForCompletion = result.deadlineForCompletion;
    });
  }

  private getAllInitial() {
    this.requestService.opnTeamMembersGetAllInitial(this.requestId).then(result => {
      this.items = result;
    })
  }

  private getAll() {
    this.requestService.opnTeamMembersGetAll(this.requestId).then(result => {
      this.items = result;
    })
  }

  showDeleteModalFor(id: number) {
    this.idForDelete = id;
    this.showDeleteModal = true;
  }

  closeDeleteModal() {
    this.idForDelete = 0;
    this.showDeleteModal = false;
  }

  delete() {
    if (this.idForDelete > 0) {
      this.opnTeamMembersService.delete(this.idForDelete).then(() => {
        this.closeDeleteModal();
        this.getAll();
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
      });
    }
  }

  showCreateModal() {
    if (!this.items.some(q => q.assessmentArea === null)) {
      this.opnTeamMemberComponent.createModal(this.requestId).then((success: boolean) => {
        if (success) {
          this.getAll();
          MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);
        }
      });
    } else {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Морате прво попунити сва обавезна поља у листи')]);
    }
  }

  showEditModal(teamMember: OpnTeamMemberModel) {
    this.opnTeamMemberComponent.editModal(teamMember,this.requestId).then((success: boolean) => {
      if (success) {
        this.getAll();
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно измењени')]);
      }
    });
  }

  navigateToList() {
    this.router.navigate(['/requests']);
  }
}
